import React, { Component } from 'react';
import remove from '../asset/img/remove.png';
import Validation from '../container/Validation.js';

export default class TableData extends Component{
	constructor(props){
		super(props);
		this.inputChange = this.inputChange.bind(this);
		this.buttonClick = this.buttonClick.bind(this);
		this.state = {columns:[],quantity:''};
	}

	inputChange(id){
		let value = this.state.quantity;
		if(value === ''){
			value = 0;
		}
		value = Number(value);
		this.props.change(id,value);
	}

	handleInput(value){
		if(Validation("posInteger",value)){
			if(this.props.app === "lov"){
				this.setState({quantity:value});
			}else{
				if(value <= this.props.itemqty){
					this.setState({quantity:value});
				}else{
					this.setState({quantity:this.props.itemqty});
				}
			}
		}
	}

	buttonClick(item){
		this.props.remove(item);
	}

	componentDidMount(){
		this.setState({columns:this.props.columns},function(){
			if(this.props.type==="cart"){
				let cols = this.props.columns;
				Object.keys(cols).forEach((col)=>{
					if(cols[col]===cols.quantity){
						this.setState({quantity:cols[col]});
					}
				});
			}
		});
	}

	componentDidUpdate(prevProps,prevState){	
		if(prevProps.columns !== this.props.columns){
			this.setState({columns:this.props.columns});
			if(this.props.type==="cart"){
				let cols = this.props.columns;
				Object.keys(cols).forEach((col)=>{
					if(cols[col]===cols.quantity){
						this.setState({quantity:cols[col]});
					}
				});
			}
		}
	}

	render(){
		const removeButton = {backgroundImage: 'url(' + remove + ')',
												 backgroundRepeat: 'no-repeat',
												 backgroundPosition: 'center',
												 backgroundSize: 'contain',
												 minWidth:'30px', minHeight:'24px',
												};
		let button;
		if(this.props.type === "cart"){
			button = <td className="tc bb pt1 pb1 b--silver"><button style={removeButton} className="bg-white br2" id={this.props.id} onClick={(e)=>this.buttonClick(e.target.id)}></button></td>
		}
		const cols = this.state.columns;
		const tdata = Object.keys(cols).map((col,i) => {

			if(cols[col]===cols.quantity && this.props.type==="cart"){
				return  <td key={i} className="tc mw2 bb pt1 pb1 b--silver"><input value={this.state.quantity} type="text" id={this.props.id} onBlur={(e)=>this.inputChange(e.target.id)} onChange={(e)=>this.handleInput(e.target.value)} className="ma0 mw-100 w-50 center tc"/></td>;
			}else{
				let text = cols[col];
				return <td key={i} className={this.props.cellstyle} style={{maxWidth:'400px',wordWrap:'break-word'}}>{text}</td>;
			}		
		});
		return(
				<tr className={this.props.rowstyle}>
				{tdata}
				{button}
				</tr>
		);
	}
}


// WEBPACK FOOTER //
// ./src/component/TableData.js